import { MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";
import { useMemo } from "react";

export const useScanImageSchema = () => {
  const scanImageSchema = useMemo(() => {
    return validator.object().shape({
      memo: validator.string().trim().label("人材情報や面談などのメモ").max(MAX_TEXT_INPUT_VALIDATION),
    });
  }, []);

  return { scanImageSchema };
};
